import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const TechBlogPage = () => {
  const articles = [
    {
      id: 1,
      title: 'Top 10 Gaming Apps for Android in 2025',
      excerpt: 'Discover the best gaming apps that are trending in 2025. From action-packed shooters to strategy games, find your next favorite game.',
      category: 'Gaming',
      date: 'Jan 15, 2025',
      readTime: '5 min read',
      image: 'https://public.readdy.ai/ai/img_res/e60d81a22fd067380ed37913ed90ce1b.jpg',
      link: '/tech-blog/top-gaming-apps-2025',
    },
    {
      id: 2,
      title: 'How to Stay Safe from Online Gaming Scams',
      excerpt: 'Learn essential tips to protect yourself from scams while participating in online giveaways and gaming communities.',
      category: 'Safety',
      date: 'Jan 12, 2025',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=digital%20security%20shield%20with%20lock%20icon%20protecting%20smartphone%20from%20cyber%20threats%20on%20simple%20blue%20gradient%20background%20online%20safety%20concept&width=600&height=400&seq=tech002&orientation=landscape',
      link: '/tech-blog/online-gaming-scams-safety',
    },
    {
      id: 3,
      title: 'How to Make Your Instagram Reels Go Viral in 2025',
      excerpt: 'Master the art of creating viral Instagram Reels with proven strategies, trending audio tips, and engagement techniques.',
      category: 'Social Media',
      date: 'Jan 10, 2025',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20displaying%20instagram%20reels%20interface%20with%20colorful%20gradient%20background%20trending%20social%20media%20content%20creation%20setup%20with%20ring%20light%20and%20tripod%20professional%20influencer%20workspace%20aesthetic%20flat%20lay%20composition&width=600&height=400&seq=instareel001&orientation=landscape',
      link: '/tech-blog/instagram-reels-viral-tips',
    },
    {
      id: 4,
      title: 'BGMI Pro Tips: How to Improve Your Rank',
      excerpt: 'Take your BGMI skills to the next level with these professional tips and strategies from top players.',
      category: 'Gaming',
      date: 'Jan 8, 2025',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=bgmi%20battlegrounds%20mobile%20game%20strategy%20with%20rank%20badges%20and%20tactical%20elements%20on%20simple%20teal%20gradient%20background%20gaming%20guide%20concept&width=600&height=400&seq=tech004&orientation=landscape',
      link: '/tech-blog/bgmi-pro-tips-rank',
    },
    {
      id: 5,
      title: 'How to Identify Fake Giveaways on Social Media',
      excerpt: 'Protect yourself from fake giveaways. Learn the red flags and warning signs of fraudulent giveaway posts.',
      category: 'Safety',
      date: 'Jan 5, 2025',
      readTime: '5 min read',
      image: 'https://readdy.ai/api/search-image?query=social%20media%20warning%20alert%20icon%20with%20magnifying%20glass%20detecting%20fake%20posts%20on%20simple%20orange%20gradient%20background%20online%20safety%20awareness&width=600&height=400&seq=tech005&orientation=landscape',
      link: '/tech-blog/fake-giveaways-guide',
    },
    {
      id: 6,
      title: 'Best Apps for Screen Recording Your Gameplay',
      excerpt: 'Want to share your epic gaming moments? Check out these top screen recording apps for mobile gamers.',
      category: 'Tech Tools',
      date: 'Jan 3, 2025',
      readTime: '4 min read',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20video%20recording%20interface%20and%20play%20button%20on%20simple%20purple%20gradient%20background%20mobile%20screen%20recording%20app%20concept&width=600&height=400&seq=tech006&orientation=landscape',
      link: '/tech-blog/screen-recording-apps',
    },
    {
      id: 7,
      title: 'Understanding In-Game Currencies: Diamonds, UC, and More',
      excerpt: 'A complete guide to understanding different in-game currencies and how to use them wisely.',
      category: 'Gaming',
      date: 'Dec 30, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=gaming%20currency%20coins%20diamonds%20and%20uc%20tokens%20glowing%20on%20simple%20gradient%20background%20virtual%20money%20concept%20clean%20design&width=600&height=400&seq=tech007&orientation=landscape',
      link: '/tech-blog/in-game-currencies-guide',
    },
    {
      id: 8,
      title: 'How to Optimize Your Phone for Better Gaming Performance',
      excerpt: 'Boost your mobile gaming experience with these simple optimization tips and settings adjustments.',
      category: 'Tech Tips',
      date: 'Dec 28, 2024',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20performance%20boost%20icon%20speed%20meter%20and%20optimization%20symbols%20on%20simple%20green%20gradient%20background%20mobile%20gaming%20optimization&width=600&height=400&seq=tech008&orientation=landscape',
      link: '/tech-blog/phone-gaming-optimization',
    },
  ];

  const categories = ['All', 'Gaming', 'Safety', 'Tech Tools', 'Tech Tips', 'Social Media'];

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-600 via-blue-500 to-cyan-500 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20technology%20abstract%20background%20with%20digital%20network%20connections%20circuit%20patterns%20and%20glowing%20elements%20in%20blue%20colors%20tech%20blog%20concept&width=1920&height=600&seq=techbloghero001&orientation=landscape"
            alt="Tech Blog Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-white mb-6">
            Tech Guides &amp; Tutorials
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Stay updated with the latest gaming tips, tech guides, and online safety information
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="bg-white border-b border-gray-200 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-4 overflow-x-auto">
            {categories.map((category) => (
              <button
                key={category}
                className={`px-6 py-2 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  category === 'All'
                    ? 'bg-blue-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 group"
              >
                <div className="w-full h-56">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-3 py-1 bg-blue-100 text-blue-600 text-xs font-semibold rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-gray-500">{article.readTime}</span>
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-blue-500 transition-colors duration-300">
                    {article.title}
                  </h2>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{article.date}</span>
                    <Link
                      to={article.link}
                      className="text-blue-500 font-semibold text-sm hover:text-blue-600 flex items-center space-x-1 cursor-pointer"
                    >
                      <span>Read More</span>
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Load More Button */}
          <div className="text-center mt-12">
            <button className="bg-blue-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Load More Articles
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border border-white/20">
            <i className="ri-mail-line text-6xl text-white mb-6"></i>
            <h2 className="text-4xl font-bold text-white mb-4">Stay Updated</h2>
            <p className="text-xl text-blue-100 mb-8">
              Get the latest gaming tips, tech guides, and giveaway updates delivered to your inbox
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-4 rounded-full text-gray-900 focus:outline-none focus:ring-4 focus:ring-white/50"
              />
              <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold hover:bg-blue-50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TechBlogPage;
